var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconXCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C5.9 1 1 5.9 1 12C1 18.1 5.9 23 12 23C18.1 23 23 18.1 23 12C23 5.9 18.1 1 12 1ZM12 21C7 21 3 17 3 12C3 7 7 3 12 3C17 3 21 7 21 12C21 17 17 21 12 21ZM15.7 8.3C15.3 7.9 14.7 7.9 14.3 8.3L12 10.6L9.7 8.3C9.3 7.9 8.7 7.9 8.3 8.3C7.9 8.7 7.9 9.3 8.3 9.7L10.6 12L8.3 14.3C7.9 14.7 7.9 15.3 8.3 15.7C8.5 15.9 8.7 16 9 16C9.3 16 9.5 15.9 9.7 15.7L12 13.4L14.3 15.7C14.5 15.9 14.8 16 15 16C15.2 16 15.5 15.9 15.7 15.7C16.1 15.3 16.1 14.7 15.7 14.3L13.4 12L15.7 9.7C16.1 9.3 16.1 8.7 15.7 8.3Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconXCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconXCircle.0ad62105a6842ee8dfdbd6205b136819.svg";